/*const optionsPartido = [
    {"value":0,"label":""},
    {"value":1,"label":"ADOLFO ALSINA"},
    {"value":51,"label":"ADOLFO GONZÁLES CHAVES"},
    {"value":2,"label":"ALBERTI"},{"value":3,"label":"ALMIRANTE BROWN"},
    {"value":10,"label":"ARRECIFES"},{"value":4,"label":"AVELLANEDA"},
    {"value":5,"label":"AYACUCHO"},{"value":6,"label":"AZUL"},
    {"value":7,"label":"BAHÍA BLANCA"},{"value":8,"label":"BALCARCE"},
    {"value":9,"label":"BARADERO"},{"value":53,"label":"BENITO JUÁREZ"},
    {"value":120,"label":"BERAZATEGUI"},{"value":114,"label":"BERISSO"},
    {"value":11,"label":"BOLÍVAR"},{"value":12,"label":"BRAGADO"},
    {"value":13,"label":"BRANDSEN"},{"value":14,"label":"CAMPANA"},
    {"value":15,"label":"CAÑUELAS"},{"value":121,"label":"CAPITÁN SARMIENTO"},
    {"value":16,"label":"CARLOS CASARES"},{"value":17,"label":"CARLOS TEJEDOR"},
    {"value":18,"label":"CARMEN DE ARECO"},{"value":20,"label":"CASTELLI"},
    {"value":26,"label":"CHACABUCO"},{"value":27,"label":"CHASCOMÚS"},
    {"value":28,"label":"CHIVILCOY"},{"value":21,"label":"COLÓN"},
    {"value":113,"label":"CORONEL DE MARINA LEONARDO ROSALES"},{"value":22,"label":"CORONEL DORREGO"},
    {"value":23,"label":"CORONEL PRINGLES"},{"value":24,"label":"CORONEL SUÁREZ"},
    {"value":19,"label":"DAIREAUX"},{"value":29,"label":"DOLORES"},

    {"value":115,"label":"ENSENADA"},{"value":118,"label":"ESCOBAR"},
    {"value":30,"label":"ESTEBAN ECHEVERRÍA"},{"value":31,"label":"EXALTACIÓN DE LA CRUZ"},
    {"value":130,"label":"EZEIZA"},{"value":32,"label":"FLORENCIO VARELA"},
    {"value":128,"label":"FLORENTINO AMEGHINO"},{"value":33,"label":"GENERAL ALVARADO"},
    {"value":34,"label":"GENERAL ALVEAR"},{"value":35,"label":"GENERAL ARENALES"},
    
    {"value":36,"label":"GENERAL BELGRANO"},{"value":37,"label":"GENERAL GUIDO"},
    {"value":40,"label":"GENERAL LA MADRID"},{"value":41,"label":"GENERAL LAS HERAS"},
    {"value":42,"label":"GENERAL LAVALLE"},{"value":39,"label":"GENERAL MADARIAGA"},
    {"value":43,"label":"GENERAL PAZ"},{"value":44,"label":"GENERAL PINTO"},
    {"value":45,"label":"GENERAL PUEYRREDÓN"},{"value":46,"label":"GENERAL RODRÍGUEZ"},
    
    {"value":47,"label":"GENERAL SAN MARTÍN"},{"value":49,"label":"GENERAL VIAMONTE"},
    {"value":50,"label":"GENERAL VILLEGAS"},{"value":52,"label":"GUAMINÍ"},
    {"value":119,"label":"HIPÓLITO YRIGOYEN"},{"value":135,"label":"HURLINGHAM"},
    {"value":136,"label":"ITUZAINGÓ"},{"value":132,"label":"JOSÉ C. PAZ"},
    {"value":54,"label":"JUNÍN"},{"value":123,"label":"LA COSTA"},
    
    {"value":70,"label":"LA MATANZA"},{"value":55,"label":"LA PLATA"},
    {"value":25,"label":"LANÚS"},{"value":56,"label":"LAPRIDA"},
    {"value":58,"label":"LAS FLORES"},{"value":59,"label":"LEANDRO N. ALEM"},
    {"value":137,"label":"LEZAMA"},{"value":60,"label":"LINCOLN"},
    {"value":61,"label":"LOBERÍA"},{"value":62,"label":"LOBOS"},
    
    {"value":63,"label":"LOMAS DE ZAMORA"},{"value":64,"label":"LUJÁN"},
    {"value":65,"label":"MAGDALENA"},{"value":66,"label":"MAIPÚ"},
    {"value":133,"label":"MALVINAS ARGENTINAS"},{"value":69,"label":"MAR CHIQUITA"},
    {"value":68,"label":"MARCOS PAZ"},{"value":71,"label":"MERCEDES"},
    {"value":72,"label":"MERLO"},{"value":73,"label":"MONTE"},
    
    {"value":126,"label":"MONTE HERMOSO"},{"value":74,"label":"MORENO"},
    {"value":101,"label":"MORÓN"},{"value":75,"label":"NAVARRO"},
    {"value":76,"label":"NECOCHEA"},{"value":77,"label":"NUEVE DE JULIO"},
    {"value":78,"label":"OLAVARRÍA"},{"value":79,"label":"PATAGONES"},
    {"value":80,"label":"PEHUAJÓ"},{"value":81,"label":"PELLEGRINI"},
    
    {"value":82,"label":"PERGAMINO"},{"value":83,"label":"PILA"},
    {"value":84,"label":"PILAR"},{"value":124,"label":"PINAMAR"},
    {"value":129,"label":"PRESIDENTE PERÓN"},{"value":85,"label":"PUAN"},
    {"value":134,"label":"PUNTA INDIO"},{"value":86,"label":"QUILMES"},
    {"value":87,"label":"RAMALLO"},{"value":88,"label":"RAUCH"},
    
    {"value":89,"label":"RIVADAVIA"},{"value":90,"label":"ROJAS"},
    {"value":91,"label":"ROQUE PÉREZ"},{"value":92,"label":"SAAVEDRA"},
    {"value":93,"label":"SALADILLO"},{"value":122,"label":"SALLIQUELÓ"},
    {"value":67,"label":"SALTO"},{"value":94,"label":"SAN ANDRÉS DE GILES"},
    {"value":95,"label":"SAN ANTONIO DE ARECO"},{"value":116,"label":"SAN CAYETANO"},
    
    {"value":96,"label":"SAN FERNANDO"},{"value":97,"label":"SAN ISIDRO"},
    {"value":131,"label":"SAN MIGUEL"},{"value":98,"label":"SAN NICOLÁS"},
    {"value":99,"label":"SAN PEDRO"},{"value":100,"label":"SAN VICENTE"},
    {"value":102,"label":"SUIPACHA"},{"value":103,"label":"TANDIL"},
    {"value":104,"label":"TAPALQUÉ"},{"value":57,"label":"TIGRE"},
    
    {"value":105,"label":"TORDILLO"},{"value":106,"label":"TORNQUIST"},
    {"value":107,"label":"TRENQUE LAUQUEN"},{"value":108,"label":"TRES ARROYOS"},
    {"value":117,"label":"TRES DE FEBRERO"},{"value":127,"label":"TRES LOMAS"},
    {"value":109,"label":"VEINTICINCO DE MAYO"},{"value":110,"label":"VICENTE LÓPEZ"},
    {"value":125,"label":"VILLA GESELL"},{"value":111,"label":"VILLARINO"},
    {"value":38,"label":"ZÁRATE"}];

*/
//{ "value": 0, "label": ""},
const optionsPartido = [
    { "value": "1", "seccion_electoral": "Sexta Sección", "label": "Adolfo Alsina", "region": "INTERIOR - 50 MIL HAB." },//6007
    { "value": "51", "seccion_electoral": "Sexta Sección", "label": "Adolfo Gonzales Chaves", "region": "INTERIOR - 50 MIL HAB." },//6014
    { "value": "2", "seccion_electoral": "Cuarta Sección", "label": "Alberti", "region": "INTERIOR - 50 MIL HAB." },//6021
    { "value": "3", "seccion_electoral": "Tercera Sección", "label": "Almirante Brown", "region": "RMBA" },//6028
    { "value": "10", "seccion_electoral": "Segunda Sección", "label": "Arrecifes", "region": "INTERIOR - 50 MIL HAB." },//6077
    { "value": "4", "seccion_electoral": "Tercera Sección", "label": "Avellaneda", "region": "RMBA" },//6035
    { "value": "5", "seccion_electoral": "Quinta Seccion", "label": "Ayacucho", "region": "INTERIOR - 50 MIL HAB." },//6042
    { "value": "6", "seccion_electoral": "Séptima Sección", "label": "Azul", "region": "INTERIOR + 50 MIL HAB." },//6049
    { "value": "7", "seccion_electoral": "Sexta Sección", "label": "Bahía Blanca", "region": "INTERIOR + 50 MIL HAB." },//6056
    { "value": "8", "seccion_electoral": "Quinta Seccion", "label": "Balcarce", "region": "INTERIOR + 50 MIL HAB." },//6063
    { "value": "9", "seccion_electoral": "Segunda Sección", "label": "Baradero", "region": "INTERIOR - 50 MIL HAB." },//6070
    { "value": "53", "seccion_electoral": "Sexta Sección", "label": "Benito Juárez", "region": "INTERIOR - 50 MIL HAB." },//6084
    { "value": "120", "seccion_electoral": "Tercera Sección", "label": "Berazategui", "region": "RMBA" },//6091
    { "value": "114", "seccion_electoral": "Tercera Sección", "label": "Berisso", "region": "RMBA" },//6098
    { "value": "11", "seccion_electoral": "Séptima Sección", "label": "Bolívar", "region": "INTERIOR - 50 MIL HAB." },//6105
    { "value": "12", "seccion_electoral": "Cuarta Sección", "label": "Bragado", "region": "INTERIOR - 50 MIL HAB." },//6112
    { "value": "13", "seccion_electoral": "Tercera Sección", "label": "Brandsen", "region": "RMBA" },//6119
    { "value": "14", "seccion_electoral": "Primera Sección", "label": "Campana", "region": "RMBA" },//6126
    { "value": "15", "seccion_electoral": "Tercera Sección", "label": "Cañuelas", "region": "RMBA" },//6134
    { "value": "121", "seccion_electoral": "Segunda Sección", "label": "Capitán Sarmiento", "region": "INTERIOR - 50 MIL HAB." },//6140
    { "value": "16", "seccion_electoral": "Cuarta Sección", "label": "Carlos Casares", "region": "INTERIOR - 50 MIL HAB." },//6147
    { "value": "17", "seccion_electoral": "Cuarta Sección", "label": "Carlos Tejedor", "region": "INTERIOR - 50 MIL HAB." },//6154
    { "value": "18", "seccion_electoral": "Segunda Sección", "label": "Carmen de Areco", "region": "INTERIOR - 50 MIL HAB." },//6161
    { "value": "20", "seccion_electoral": "Quinta Seccion", "label": "Castelli", "region": "INTERIOR - 50 MIL HAB." },//6168
    { "value": "26", "seccion_electoral": "Cuarta Sección", "label": "Chacabuco", "region": "INTERIOR + 50 MIL HAB." },//6210
    { "value": "27", "seccion_electoral": "Quinta Seccion", "label": "Chascomús", "region": "INTERIOR - 50 MIL HAB." },//6218
    { "value": "28", "seccion_electoral": "Cuarta Sección", "label": "Chivilcoy", "region": "INTERIOR + 50 MIL HAB." },//6224
    { "value": "21", "seccion_electoral": "Segunda Sección", "label": "Colón", "region": "INTERIOR - 50 MIL HAB." },//6175
    { "value": "113", "seccion_electoral": "Sexta Sección", "label": "Coronel Rosales", "region": "INTERIOR + 50 MIL HAB." },//6182 Coronel de Marina Leonardo Rosales
    { "value": "22", "seccion_electoral": "Sexta Sección", "label": "Coronel Dorrego", "region": "INTERIOR - 50 MIL HAB." },//6189
    { "value": "23", "seccion_electoral": "Sexta Sección", "label": "Coronel Pringles", "region": "INTERIOR - 50 MIL HAB." },//6196
    { "value": "24", "seccion_electoral": "Sexta Sección", "label": "Coronel Suárez", "region": "INTERIOR - 50 MIL HAB." },//6203
    { "value": "19", "seccion_electoral": "Sexta Sección", "label": "Daireaux", "region": "INTERIOR - 50 MIL HAB." },//6231
    { "value": "29", "seccion_electoral": "Quinta Seccion", "label": "Dolores", "region": "INTERIOR - 50 MIL HAB." },//6238    

    { "value": "115", "seccion_electoral": "Tercera Sección", "label": "Ensenada", "region": "RMBA" },//6245
    { "value": "118", "seccion_electoral": "Primera Sección", "label": "Escobar", "region": "RMBA" },//6252
    { "value": "30", "seccion_electoral": "Tercera Sección", "label": "Esteban Echeverría", "region": "RMBA" },//6260
    { "value": "31", "seccion_electoral": "Segunda Sección", "label": "Exaltación de la Cruz", "region": "RMBA" },//6266
    { "value": "130", "seccion_electoral": "Tercera Sección", "label": "Ezeiza", "region": "RMBA" },//6270
    { "value": "32", "seccion_electoral": "Tercera Sección", "label": "Florencio Varela", "region": "RMBA" },//6274
    { "value": "128", "seccion_electoral": "Cuarta Sección", "label": "Florentino Ameghino", "region": "INTERIOR - 50 MIL HAB." },//6277
    { "value": "33", "seccion_electoral": "Quinta Seccion", "label": "General Alvarado", "region": "INTERIOR - 50 MIL HAB." },//6280
    { "value": "34", "seccion_electoral": "Séptima Sección", "label": "General Alvear", "region": "INTERIOR - 50 MIL HAB." },//6287
    { "value": "35", "seccion_electoral": "Cuarta Sección", "label": "General Arenales", "region": "INTERIOR - 50 MIL HAB." },//6294

    { "value": "36", "seccion_electoral": "Quinta Seccion", "label": "General Belgrano", "region": "INTERIOR - 50 MIL HAB." },//6301
    { "value": "37", "seccion_electoral": "Quinta Seccion", "label": "General Guido", "region": "INTERIOR - 50 MIL HAB." },//6308
    //38 es ZARARTE ---esta abajo en la lista
    { "value": "39", "seccion_electoral": "Quinta Seccion", "label": "General Madariaga", "region": "INTERIOR - 50 MIL HAB." },//6315
    { "value": "40", "seccion_electoral": "Sexta Sección", "label": "General La Madrid", "region": "INTERIOR - 50 MIL HAB." },//6322
    { "value": "41", "seccion_electoral": "Primera Sección", "label": "General Las Heras", "region": "RMBA" },//6329
    { "value": "42", "seccion_electoral": "Quinta Seccion", "label": "General Lavalle", "region": "INTERIOR - 50 MIL HAB." },//6336
    { "value": "43", "seccion_electoral": "Quinta Seccion", "label": "General Paz", "region": "INTERIOR - 50 MIL HAB." },//6343
    { "value": "44", "seccion_electoral": "Cuarta Sección", "label": "General Pinto", "region": "INTERIOR - 50 MIL HAB." },//6351
    { "value": "45", "seccion_electoral": "Quinta Seccion", "label": "General Pueyrredón", "region": "INTERIOR + 50 MIL HAB." },//6357
    { "value": "46", "seccion_electoral": "Primera Sección", "label": "General Rodríguez", "region": "RMBA" },//6364

    { "value": "47", "seccion_electoral": "Primera Sección", "label": "General San Martín", "region": "RMBA" },//6371
    //NO HAY 48
    { "value": "49", "seccion_electoral": "Cuarta Sección", "label": "General Viamonte", "region": "INTERIOR - 50 MIL HAB." },//6385 //
    { "value": "50", "seccion_electoral": "Cuarta Sección", "label": "General Villegas", "region": "INTERIOR - 50 MIL HAB." },//6392
    { "value": "52", "seccion_electoral": "Sexta Sección", "label": "Guaminí", "region": "INTERIOR - 50 MIL HAB." },//6399
    { "value": "119", "seccion_electoral": "Cuarta Sección", "label": "Hipólito Yrigoyen", "region": "INTERIOR - 50 MIL HAB." },//6406
    { "value": "135", "seccion_electoral": "Primera Sección", "label": "Hurlingham", "region": "RMBA" },//6408
    { "value": "136", "seccion_electoral": "Primera Sección", "label": "Ituzaingó", "region": "RMBA" },//6410
    { "value": "132", "seccion_electoral": "Primera Sección", "label": "José C. Paz", "region": "RMBA" },//6412
    { "value": "54", "seccion_electoral": "Cuarta Sección", "label": "Junín", "region": "INTERIOR + 50 MIL HAB." },//6413
    { "value": "123", "seccion_electoral": "Quinta Seccion", "label": "La Costa", "region": "INTERIOR + 50 MIL HAB." },//6420

    { "value": "70", "seccion_electoral": "Tercera Sección", "label": "La Matanza", "region": "RMBA" },//6427
    { "value": "55", "seccion_electoral": "Octava Sección", "label": "La Plata", "region": "RMBA" },//6441
    { "value": "25", "seccion_electoral": "Tercera Sección", "label": "Lanús", "region": "RMBA" },//6434
    { "value": "56", "seccion_electoral": "Sexta Sección", "label": "Laprida", "region": "INTERIOR - 50 MIL HAB." },//6448
    { "value": "58", "seccion_electoral": "Quinta Seccion", "label": "Las Flores", "region": "INTERIOR - 50 MIL HAB." },//6455
    { "value": "59", "seccion_electoral": "Cuarta Sección", "label": "Leandro N. Alem", "region": "INTERIOR - 50 MIL HAB." },//6462
    { "value": "137", "seccion_electoral": "Quinta Seccion", "label": "Lezama", "region": "INTERIOR - 50 MIL HAB." },//6466
    { "value": "60", "seccion_electoral": "Cuarta Sección", "label": "Lincoln", "region": "INTERIOR - 50 MIL HAB." },//6469
    { "value": "61", "seccion_electoral": "Quinta Seccion", "label": "Lobería", "region": "INTERIOR - 50 MIL HAB." },//6476
    { "value": "62", "seccion_electoral": "Tercera Sección", "label": "Lobos", "region": "INTERIOR - 50 MIL HAB." },//6483

    { "value": "63", "seccion_electoral": "Tercera Sección", "label": "Lomas de Zamora", "region": "RMBA" },//6490
    { "value": "64", "seccion_electoral": "Primera Sección", "label": "Luján", "region": "RMBA" },//6497
    { "value": "65", "seccion_electoral": "Tercera Sección", "label": "Magdalena", "region": "INTERIOR - 50 MIL HAB." },//6505
    { "value": "66", "seccion_electoral": "Quinta Seccion", "label": "Maipú", "region": "INTERIOR - 50 MIL HAB." },//6511
    { "value": "133", "seccion_electoral": "Primera Sección", "label": "Malvinas Argentinas", "region": "RMBA" },//6515
    { "value": "69", "seccion_electoral": "Quinta Seccion", "label": "Mar Chiquita", "region": "INTERIOR - 50 MIL HAB." },//6518
    { "value": "68", "seccion_electoral": "Primera Sección", "label": "Marcos Paz", "region": "RMBA" },//6525
    { "value": "71", "seccion_electoral": "Primera Sección", "label": "Mercedes", "region": "INTERIOR + 50 MIL HAB." },//6532
    { "value": "72", "seccion_electoral": "Primera Sección", "label": "Merlo", "region": "RMBA" },//6539
    { "value": "73", "seccion_electoral": "Quinta Seccion", "label": "Monte", "region": "INTERIOR - 50 MIL HAB." },//6547

    { "value": "126", "seccion_electoral": "Sexta Sección", "label": "Monte Hermoso", "region": "INTERIOR - 50 MIL HAB." },//6553
    { "value": "74", "seccion_electoral": "Primera Sección", "label": "Moreno", "region": "RMBA" },//6560
    { "value": "101", "seccion_electoral": "Primera Sección", "label": "Morón", "region": "RMBA" },//6568
    { "value": "75", "seccion_electoral": "Primera Sección", "label": "Navarro", "region": "INTERIOR - 50 MIL HAB." },//6574
    { "value": "76", "seccion_electoral": "Quinta Seccion", "label": "Necochea", "region": "INTERIOR + 50 MIL HAB." },//6581
    { "value": "77", "seccion_electoral": "Cuarta Sección", "label": "Nueve de Julio", "region": "INTERIOR + 50 MIL HAB." },//6588
    { "value": "78", "seccion_electoral": "Séptima Sección", "label": "Olavarría", "region": "INTERIOR + 50 MIL HAB." },//6595
    { "value": "79", "seccion_electoral": "Sexta Sección", "label": "Patagones", "region": "INTERIOR - 50 MIL HAB." },//6602
    { "value": "80", "seccion_electoral": "Cuarta Sección", "label": "Pehuajó", "region": "INTERIOR - 50 MIL HAB." },//6609
    { "value": "81", "seccion_electoral": "Sexta Sección", "label": "Pellegrini", "region": "INTERIOR - 50 MIL HAB." },//6616

    { "value": "82", "seccion_electoral": "Segunda Sección", "label": "Pergamino", "region": "INTERIOR + 50 MIL HAB." },//6623
    { "value": "83", "seccion_electoral": "Quinta Seccion", "label": "Pila", "region": "INTERIOR - 50 MIL HAB." },//6630
    { "value": "84", "seccion_electoral": "Primera Sección", "label": "Pilar", "region": "RMBA" },//6638
    { "value": "124", "seccion_electoral": "Quinta Seccion", "label": "Pinamar", "region": "INTERIOR - 50 MIL HAB." },//6644
    { "value": "129", "seccion_electoral": "Tercera Sección", "label": "Presidente Perón", "region": "RMBA" },//6648
    { "value": "85", "seccion_electoral": "Sexta Sección", "label": "Puan", "region": "INTERIOR - 50 MIL HAB." },//6651
    { "value": "134", "seccion_electoral": "Tercera Sección", "label": "Punta Indio", "region": "INTERIOR - 50 MIL HAB." },//6655
    { "value": "86", "seccion_electoral": "Tercera Sección", "label": "Quilmes", "region": "RMBA" },//6658
    { "value": "87", "seccion_electoral": "Segunda Sección", "label": "Ramallo", "region": "INTERIOR - 50 MIL HAB." },//6665
    { "value": "88", "seccion_electoral": "Quinta Seccion", "label": "Rauch", "region": "INTERIOR - 50 MIL HAB." },//6672

    { "value": "89", "seccion_electoral": "Cuarta Sección", "label": "Rivadavia", "region": "INTERIOR - 50 MIL HAB." },//6679
    { "value": "90", "seccion_electoral": "Segunda Sección", "label": "Rojas", "region": "INTERIOR - 50 MIL HAB." },//6686
    { "value": "91", "seccion_electoral": "Séptima Sección", "label": "Roque Pérez", "region": "INTERIOR - 50 MIL HAB." },//6693
    { "value": "92", "seccion_electoral": "Sexta Sección", "label": "Saavedra", "region": "INTERIOR - 50 MIL HAB." },//6700
    { "value": "93", "seccion_electoral": "Séptima Sección", "label": "Saladillo", "region": "INTERIOR - 50 MIL HAB." },//6707
    { "value": "122", "seccion_electoral": "Sexta Sección", "label": "Salliqueló", "region": "INTERIOR - 50 MIL HAB." },//6721
    { "value": "67", "seccion_electoral": "Segunda Sección", "label": "Salto", "region": "INTERIOR - 50 MIL HAB." },//6714
    { "value": "94", "seccion_electoral": "Segunda Sección", "label": "San Andrés de Giles", "region": "INTERIOR - 50 MIL HAB." },//6728
    { "value": "95", "seccion_electoral": "Segunda Sección", "label": "San Antonio de Areco", "region": "INTERIOR - 50 MIL HAB." },//6735
    { "value": "116", "seccion_electoral": "Quinta Seccion", "label": "San Cayetano", "region": "INTERIOR - 50 MIL HAB." },//6742

    { "value": "96", "seccion_electoral": "Primera Sección", "label": "San Fernando", "region": "RMBA" },//6749
    { "value": "97", "seccion_electoral": "Primera Sección", "label": "San Isidro", "region": "RMBA" },//6756
    { "value": "131", "seccion_electoral": "Primera Sección", "label": "San Miguel", "region": "RMBA" },//6760
    { "value": "98", "seccion_electoral": "Segunda Sección", "label": "San Nicolás", "region": "INTERIOR + 50 MIL HAB." },//6763
    { "value": "99", "seccion_electoral": "Segunda Sección", "label": "San Pedro", "region": "INTERIOR + 50 MIL HAB." },//6770
    { "value": "100", "seccion_electoral": "Tercera Sección", "label": "San Vicente", "region": "RMBA" },//6778
    { "value": "102", "seccion_electoral": "Primera Sección", "label": "Suipacha", "region": "INTERIOR - 50 MIL HAB." },//6784
    { "value": "103", "seccion_electoral": "Quinta Seccion", "label": "Tandil", "region": "INTERIOR + 50 MIL HAB." },//6791
    { "value": "104", "seccion_electoral": "Séptima Sección", "label": "Tapalqué", "region": "INTERIOR - 50 MIL HAB." },//6798
    { "value": "57", "seccion_electoral": "Primera Sección", "label": "Tigre", "region": "RMBA" },//6805   

    { "value": "105", "seccion_electoral": "Quinta Seccion", "label": "Tordillo", "region": "INTERIOR - 50 MIL HAB." },//6812
    { "value": "106", "seccion_electoral": "Sexta Sección", "label": "Tornquist", "region": "INTERIOR - 50 MIL HAB." },//6819
    { "value": "107", "seccion_electoral": "Cuarta Sección", "label": "Trenque Lauquen", "region": "INTERIOR - 50 MIL HAB." },//6826
    { "value": "108", "seccion_electoral": "Sexta Sección", "label": "Tres Arroyos", "region": "INTERIOR + 50 MIL HAB." },//6833
    { "value": "117", "seccion_electoral": "Primera Sección", "label": "Tres de Febrero", "region": "RMBA" },//6840
    { "value": "127", "seccion_electoral": "Sexta Sección", "label": "Tres Lomas", "region": "INTERIOR - 50 MIL HAB." },//6847
    { "value": "109", "seccion_electoral": "Séptima Sección", "label": "Veinticinco de Mayo", "region": "INTERIOR - 50 MIL HAB." },//6854
    { "value": "110", "seccion_electoral": "Primera Sección", "label": "Vicente López", "region": "RMBA" },//6861
    { "value": "125", "seccion_electoral": "Quinta Seccion", "label": "Villa Gesell", "region": "INTERIOR - 50 MIL HAB." },//6868
    { "value": "111", "seccion_electoral": "Sexta Sección", "label": "Villarino", "region": "INTERIOR - 50 MIL HAB." },//6875
    { "value": "38", "seccion_electoral": "Segunda Sección", "label": "Zárate", "region": "RMBA" },//6882

    { "value": "999", "seccion_electoral": "", "label": "CABA", "region": "" },
]

const optionsTipoSubsidio = [
    //{value: "", label: "Seleccionar..."},
    { value: "Subsidio a municipio", label: "Subsidio a municipio" },
    { value: "Subsidio a ONG", label: "Subsidio a ONG" },
    { value: "Subsidio a Universidades", label: "Subsidio a Universidades" },
    { value: "Otro", label: "Otro" }
]

const optionsOrganismoSolicitante = [
    { value: "Subsidio a municipio", label: "Municipio" },
    { value: "Subsidio a ONG", label: "ONG" },
    { value: "Otro", label: "Otro" }
]

//listado original
/*
const optionsEncargadoProyecto = [
    //{value: "", label: "Seleccionar..."},
    {value: "Agustín Rocha", label: "Agustín Rocha"},
    {value: "Gustavo Gómez Llera", label: "Gustavo Gómez Llera"},
    {value: "Camila Di Biase", label: "Camila Di Biase"},
    {value: "Matías Gualchi", label: "Matías Gualchi"},
    {value: "Martín La Monica", label: "Martín La Monica"},
    {value: "Eugenia Luna", label: "Eugenia Luna"},
    {value: "Martín Saraqui", label: "Martín Saraqui"},
    {value: "María Estefanía Bernal", label: "María Estefanía Bernal"},
    {value: "María Paula Misson", label: "María Paula Misson"},
    {value: "Cecilia Ferrari", label: "Cecilia Ferrari"},
    {value: "Belén Cortese", label: "Belén Cortese"},
    {value: "Romina Pedernera", label: "Romina Pedernera"},
    {value: "Antonela Dedioniggi", label: "Antonela Dedioniggi"},
    {value: "Valeria Castillo", label: "Valeria Castillo"},
    {value: "Mariana Amigorena", label: "Mariana Amigorena"},
    {value: "Laura Oterino", label: "Laura Oterino"},
    {value: "Camila Godoy", label: "Camila Godoy"},
    {value: "Rocío Cremonte", label: "Rocío Cremonte"},
    {value: "Otro", label: "Otro"}   
]*/

const optionsEncargadoProyecto = [
    //{value: "", label: "Seleccionar..."},
    { value: "Agustín Rocha", label: "Agustín Rocha" },
    { value: "Aurelio Benito Lias", label: "Aurelio Benito Lias" },
    { value: "Ayelén Matteo", label: "Ayelén Matteo" },
    { value: "Antonela Dedioniggi", label: "Antonela Dedioniggi" },
    { value: "Belén Cortese", label: "Belén Cortese" },
    { value: "Camila Di Biase", label: "Camila Di Biase" },
    { value: "Cecilia Ferrari", label: "Cecilia Ferrari" },
    { value: "Celeste Esayán", label: "Celeste Esayán" },
    { value: "Emilia Martini", label: "Emilia Martini" },
    { value: "María Estefanía Bernal", label: "Estefanía Bernal" },
    { value: "Erica Osterrrieth", label: "Erica Osterrrieth" },
    { value: "Fernanda Barragán", label: "Fernanda Barragán" },
    { value: "Eugenia Luna", label: "Eugenia Luna" },
    { value: "Facundo Oviedo", label: "Facundo Oviedo" },
    { value: "Gustavo Gómez Llera", label: "Gustavo Gómez Llera" },
    { value: "Luca Tangorra", label: "Luca Tangorra" },

    { value: "Ignacio Polistina", label: "Ignacio Polistina" },
    { value: "Javier Lachener", label: "Javier Lachener" },
    { value: "Laura Oterino", label: "Laura Oterino" },
    { value: "Mariana Amigorena", label: "Mariana Amigorena" },
    { value: "Mariano Noceto", label: "Mariano Noceto" },
    { value: "Martín La Monica", label: "Martín La Monica" },
    { value: "Martín Saraqui", label: "Martín Saraqui" },
    { value: "Matías Gualchi", label: "Matías Gualchi" },
    { value: "Carla Miranda Solla", label: "Carla Miranda Solla" },
    { value: "María Paula Misson", label: "María Paula Misson" },
    { value: "Miryam Denegri", label: "Miryam Denegri" },
    { value: "Paula Kammerath", label: "Paula Kammerath" },
    { value: "Norma Aramayo", label: "Norma Aramayo" },
    { value: "Roberto Perito", label: "Roberto Perito" },
    { value: "Romina Zapata", label: "Romina Zapata" },
    { value: "Romina Pedernera", label: "Romina Pedernera" },
    { value: "Valeria Castillo", label: "Valeria Castillo" },
    { value: "Valentín Damia", label: "Valentín Damia" },
    { value: "Isabella Caballieri", label: "Isabella Caballieri" },
    { value: "Luz Garcia Vasquez", label: "Luz Garcia Vasquez" },
    //{value: "Camila Godoy", label: "Camila Godoy"},
    { value: "Rocío Cremonte", label: "Rocío Cremonte" },
    { value: "Otro", label: "Otro" }
]

//cambio de opciones 7-FEB-25
/*const optionsPrograma = [
    //{value: "", label: "Seleccionar..."},
    {value: "Mejora del Hábitat", label: "Mejora del Hábitat"},
    {value: "Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat",label: "Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat"},
    {value: "Programa de Financiación para la capacitación y difusión de la Gestión del hábitat bonaerense",label: "Programa de Financiación para la capacitación y difusión de la Gestión del hábitat bonaerense"},
    {value: "Otro", label: "Otro"}
]*/

//cambio de opciones 16-FEB-2026
const optionsPrograma = [
    { value: "Financiamiento para la Mejora del Hábitat", label: "Financiamiento para la Mejora del Hábitat" },
    { value: "Mejoras Habitacionales Trabajar en la Casa", label: "Mejoras Habitacionales \"Trabajar en la Casa\"" },
    { value: "Microcréditos para la Mejora del Hábitat", label: "Microcréditos para la Mejora del Hábitat" },
    { value: "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense", label: "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense" },
    { value: "Proyectos ambientales", label: "Proyectos ambientales" },
    { value: "Otro", label: "Otro" }
]
const optionsProgramaUNO = [
    { value: "Financiamiento para la Mejora del Hábitat", label: "Financiamiento para la Mejora del Hábitat" },
]

const optionsProgramaDOS = [
    { value: "Mejoras Habitacionales Trabajar en la Casa", label: "Mejoras Habitacionales \"Trabajar en la Casa\"" },
]

const optionsProgramaTRES = [
    { value: "Microcréditos para la Mejora del Hábitat", label: "Microcréditos para la Mejora del Hábitat" },
]

const optionsProgramaCUATRO = [
    { value: "Proyectos ambientales", label: "Proyectos ambientales" },
]

//programas para nueva area de Capacitaciones
const optionsProgramaSEIS = [
    { value: "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense", label: "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense" },
]

const optionsProgramaCINCO = [
    { value: "Otro", label: "Otro" },
]


/*
//NUEVO opciones modalidad para Programa 1 y 2
const optionsModalidadUNO = [
    {value: "", label: "Seleccionar..."},
    {value: "Equipamiento de la comunidad", label: "Equipamiento de la comunidad"},
    {value: "Mejoras habitacionales 'Trabajar en Casa'", label: "Mejoras habitacionales 'Trabajar en Casa'"},
    {value: "Infraestructura de redes públicas domiciliarias, intradomiciliarias,etc.", label: "Infraestructura de redes públicas domiciliarias, intradomiciliarias,etc."},
    {value: "Microcréditos", label: "Microcréditos"},
    {value: "Planos de Mensura", label: "Planos de Mensura"}
]

const optionsModalidadDOS = [
    {value: "", label: "Seleccionar..."},
    {value: "Soluciones habitacionales", label: "Soluciones habitacionales"},
    {value: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación", label: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación"},
    {value: "Servicio de mano de obra", label: "Servicio de mano de obra"}
]
*/

const optionsModalidadUNO = [
    { value: "Equipamiento comunitario", label: "Equipamiento comunitario" },
    { value: "Infraestructura de redes públicas domiciliarias e intradomiciliarias, etc.", label: "Infraestructura de redes públicas domiciliarias e intradomiciliarias, etc." },
    { value: "Soluciones habitacionales", label: "Soluciones habitacionales" },
    { value: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación", label: "Herramientas, ropas de trabajo, materiales, equipos, maquinarias y capacitación" },
    { value: "Servicio de mano de obra", label: "Servicio de mano de obra" }
]

const optionsModalidadDOS = [
    { value: "etapa I", label: "Etapa I" },
    { value: "etapa II", label: "Etapa II" }
]
// nohay modalidad 3
const optionsModalidadCUATRO = [
    { value: "Diplomatura universitaria", label: "Diplomatura universitaria" },
    { value: "Observatorio", label: "Observatorio" },
    { value: "Capacitaciones a la comunidad", label: "Capacitaciones a la comunidad" },
    { value: "Otras", label: "Otras" }
]

//una modalidad para cuando programa es Proyectos Ambientales
const optionsModalidadCUATRO_UNO = [
    { value: "Proyectos ambientales", label: "Proyectos ambientales" }
]

// modalidad ----> para programa seis (Financiación para la Capacitación ...) Area Responsable: Capacitaciones y Difusión
const optionsModalidadSEIS = [
    { value: "Diplomatura universitaria", label: "Diplomatura universitaria" },
    { value: "Observatorio", label: "Observatorio" },
    { value: "Capacitaciones a la comunidad", label: "Capacitaciones a la comunidad" },
    { value: "Otras", label: "Otras" }
]

const optionsTipoContratacion = [
    { value: "", label: "Seleccionar..." },
    { value: "Licitación", label: "Licitación" },
    { value: "Administración", label: "Administración" },
    { value: "Mixta", label: "Mixta" }
]
//programa 5 no tiene modalidad

const optionsEstado = [
    //{value: "", label: "Seleccionar..."},
    { value: "Análisis preliminar", label: "Análisis preliminar" },
    //{value: "Confección del expediente", label: "Confección del expediente"},
    { value: "En circuito administrativo", label: "En circuito administrativo" },
    //{value: "Confección del Convenio", label: "Confección del Convenio"},
    //{value: "Resolución", label: "Resolución"},
    { value: "Seguimiento", label: "Seguimiento" },
    { value: "Finalizado", label: "Finalizado" },
    { value: "Observado,  inactivo o suspendido", label: "Observado,  inactivo o suspendido" },
    //{value: "Inactivo o suspendido", label: "Inactivo o suspendido"}, cambio 7-FEB-25
    { value: "En guarda", label: "En guarda" },
    { value: "Rescisión", label: "Rescisión" }
    //{value: "Adenda", label: "Adenda"},
    //{value: "Otro", label: "Otro"}
]

const optionsTipoProyecto = [
    { value: "", label: "Seleccionar..." },
    { value: "Mejoramiento habitacional", label: "Mejoramiento habitacional" },
    { value: "Mejoramiento habitacional (módulos)", label: "Mejoramiento habitacional (módulos)" },
    { value: "Redes o conexiones internas", label: "Redes o conexiones internas" },
    { value: "Infraestructura barrial", label: "Infraestructura barrial" },
    { value: "Equipamiento comunitario", label: "Equipamiento comunitario" },
    { value: "Planos de mensura", label: "Planos de mensura" },
    { value: "Capacitaciones", label: "Capacitaciones" },
    { value: "Saneamiento urbano", label: "Saneamiento urbano" },
    { value: "Otros", label: "Otros" },
]

const optionsObjetoExpediente = [
    { value: "", label: "Seleccionar..." },
    { value: "Proyecto", label: "Proyecto" },
    { value: "Adenda", label: "Adenda" },
    { value: "Rendición", label: "Rendición" }
]

const optionsObjetoExpediente_Mejoras_Microcreditos = [
    { value: "", label: "Seleccionar..." },
    { value: "Proyecto", label: "Proyecto" },
    { value: "Rendición", label: "Rendición" },
    { value: "Adenda", label: "Adenda" }
]

const optionsObjetoExpediente_Proyectos = [
    { value: "", label: "Seleccionar..." },
    { value: "Proyecto", label: "Proyecto" },
    { value: "Rendición", label: "Rendición" },
    { value: "Adenda", label: "Adenda" }
]

const optionsObjeto_Tramitacion_Pagos = [
    { value: "Rendición", label: "Rendición" },
    { value: "Adenda", label: "Adenda" }
]

//select Documentación presentada (TODO/RESOLUCIÓN/DOCUMENTACIÓN para el pago)
const optionsDocumentacionPresentada = [
    { value: "Resolución", label: "Resolución" },
    { value: "Documentación para el pago", label: "Documentación para el pago" },
    { value: "Ambas", label: "Ambas" }
]

const optionsEtapaPago = [//Anticipo, 2do_pago, 3er_pago, Total
    { value: "anticipo", label: "Anticipo" },
    { value: "2do_pago", label: "2do pago" },
    { value: "3er_pago", label: "3er pago" },
    { value: "total", label: "Total" }
]

const optionsAvanceObra = [
    { value: "30", label: "30%" },
    { value: "65", label: "65%" },
    { value: "100", label: "100%" }
]

const optionsIdentificacionCatastral = [
    { value: "", label: "Seleccionar..." },
    { value: "SI", label: "Sí" },
    { value: "NO", label: "No" }
]

const optionsBarrioTipo = [
    { value: "RPPVAP", label: "Barrio RPPVAP" },
    { value: "RENABAP", label: "Barrio RENABAP" },
    { value: "OTRO", label: "Otro" }
];

const optionsAreaResponsable = [
    //{value: "", label: "Seleccionar..."},
    { value: "ÁREA DE PROYECTOS", label: "Área de obras" }, //por ahora se cambia solo el label
    { value: "ÁREA DE MEJORAS", label: "Área de mejoras" },
    { value: "ÁREA DE MICROCRÉDITOS", label: "Área de microcréditos" },
    { value: "ÁREA DE INTERVENCIÓN SOCIAL", label: "Área de intervención social" },
    { value: "ÁREA DE CAPACITACIONES", label: "Área de capacitaciones" },
    { value: "OTRA", label: "Otra" }
];

const optionsCategoria = [
    //{ value: '', label: 'Seleccionar...' },
    { value: 'social', label: 'Social' },
    { value: 'política', label: 'Política' },
    { value: 'educativa', label: 'Educativa' },
    { value: 'religiosa', label: 'Religiosa' },
    { value: 'deportiva', label: 'Deportiva' },
    { value: 'sindical', label: 'Sindical' }
];

const optionsLPO = [
    { value: "LPO", label: "SI" },
    { value: "NO", label: "NO" }
];

/*const optionsEncargadoRendicion = [
    //{value: "", label: "Seleccionar..."},
    {value: "AGUSTÍN ROCHA", label: "Agustín Rocha"},
    {value: "GUSTAVO GOMEZ LLERA", label: "Gustavo Gomez Llera"},
    {value: "CAMILA DI BIASE", label: "Camila Di Biase"},
    {value: "MATIAS GUALCHI", label: "Matías Gualchi"},
    {value: "MARTIN LA MONICA", label: "Martín La Monica"},
    {value: "EUGENIA LUNA", label: "Eugenia Luna"},
    {value: "MARTIN SARAQUI", label: "Martín Saraqui"},
    {value: "MARIA ESTEFANIA BERNAL", label: "María Estefanía Bernal"},
    {value: "MARIA PAULA MISSON", label: "María Paula Misson"},
    {value: "CECILIA FERRARI", label: "Cecilia Ferrari"},
    {value: "BELEN CORTESE", label: "Belén Cortese"},
    {value: "ROMINA PEDERNERA", label: "Romina Pedernera"},
    {value: "ANTONELA DEDIONIGGI", label: "Antonela Dedioniggi"},
    {value: "VALERIA CASTILLO", label: "Valeria Castillo"},
    {value: "MARIANA AMIGORENA", label: "Mariana Amigorena"},
    {value: "LAURA OTERIÑO", label: "Laura Oterino"},
    {value: "JAVIER LACHENER", label: "Javier Lachener"},
    {value: "ROBERTO PERITO", label: "Roberto Perito"},
    {value: "ERICA OSTERRIETH", label: "Erica Osterrith"},
    {value: "PAULA KAMERATH", label: "Paula Kamerath"},
    {value: "FACUNDO OVIEDO", label: "Facundo Oviedo"},
    {value: "IGNACIO POLISTINA", label: "Ignacio Polistina"},
    {value: "MIRIAM DENEGRI", label: "Miriam Denegri"},
    {value: "OTRO", label: "Otro"}   
]*/
const optionsEncargadoRendicion = [
    { value: "Agustín Rocha", label: "Agustín Rocha" },
    { value: "Aurelio Benito Lias", label: "Aurelio Benito Lias" },
    { value: "Ayelén Matteo", label: "Ayelén Matteo" },
    { value: "Antonela Dedioniggi", label: "Antonela Dedioniggi" },
    { value: "Belén Cortese", label: "Belén Cortese" },
    { value: "Camila Di Biase", label: "Camila Di Biase" },
    { value: "Cecilia Ferrari", label: "Cecilia Ferrari" },
    { value: "Emilia Martini", label: "Emilia Martini" },
    { value: "María Estefanía Bernal", label: "Estefanía Bernal" },
    { value: "Erica Osterrrieth", label: "Erica Osterrrieth" },
    { value: "Eugenia Luna", label: "Eugenia Luna" },
    { value: "Facundo Oviedo", label: "Facundo Oviedo" },
    { value: "Gustavo Gómez Llera", label: "Gustavo Gómez Llera" },
    { value: "Luca Tangorra", label: "Luca Tangorra" },

    { value: "Ignacio Polistina", label: "Ignacio Polistina" },
    { value: "Javier Lachener", label: "Javier Lachener" },
    { value: "Laura Oterino", label: "Laura Oterino" },
    { value: "Mariana Amigorena", label: "Mariana Amigorena" },
    { value: "Mariano Noceto", label: "Mariano Noceto" },
    { value: "Martín La Monica", label: "Martín La Monica" },
    { value: "Martín Saraqui", label: "Martín Saraqui" },
    { value: "Matías Gualchi", label: "Matías Gualchi" },
    { value: "Carla Miranda Solla", label: "Carla Miranda Solla" },
    { value: "María Paula Misson", label: "María Paula Misson" },
    { value: "Miryam Denegri", label: "Miryam Denegri" },
    { value: "Paula Kammerath", label: "Paula Kammerath" },
    { value: "Norma Aramayo", label: "Norma Aramayo" },
    { value: "Roberto Perito", label: "Roberto Perito" },
    { value: "Romina Zapata", label: "Romina Zapata" },
    { value: "Romina Pedernera", label: "Romina Pedernera" },
    { value: "Valeria Castillo", label: "Valeria Castillo" },
    { value: "Valentín Damia", label: "Valentín Damia" },
    { value: "Isabella Caballieri", label: "Isabella Caballieri" },
    { value: "Luz García Vásquez", label: "Luz García Vásquez" },
    //{value: "Camila Godoy", label: "Camila Godoy"},
    //{value: "Rocío Cremonte", label: "Rocío Cremonte"},
    { value: "Otro", label: "Otro" }
]

const optionsEncargadoSeguimiento = [
    { value: "Paula Kammerath", label: "Paula Kammerath" },
    { value: "Facundo Oviedo", label: "Facundo Oviedo" },
    { value: "Eugenia Luna", label: "Eugenia Luna" },
    { value: "Fernanda Barragán", label: "Fernanda Barragán" },
    { value: "Celeste Esayán", label: "Celeste Esayán" },
    { value: "Matías Gualchi", label: "Matías Gualchi" },
    { value: "María Paula Misson", label: "María Paula Misson" },
    { value: "Agustín Rocha", label: "Agustín Rocha" },
    { value: "Gustavo Gómez Llera", label: "Gustavo Gómez Llera" },
    { value: "Martín La Monica", label: "Martín La Monica" },
    { value: "Camila Di Biase", label: "Camila Di Biase" },
    { value: "Rocío Cremonte", label: "Rocío Cremonte" },
    { value: "María Estefanía Bernal", label: "Estefanía Bernal" },
]

// Área de Mejoras tiene sus propios encargados de seguimiento: el resto de
// las áreas responsables sigue usando la lista completa de arriba.
const optionsEncargadoSeguimientoMejoras = [
    { value: "Belén Cortese", label: "Belén Cortese" },
    { value: "Romina Zapata", label: "Romina Zapata" },
]

const optionsOrganismoEncargado = [
    { value: "", label: "Seleccionar..." },
    { value: "Municipal", label: "Municipal" },
    { value: "Empresa contratista", label: "Empresa contratista" },
    { value: "ONG", label: "ONG" },
    { value: "Otro", label: "Otro" }
]

const optionsEtapaExpediente = [
    { value: "25", label: "Salida convenio - 25%" },
    { value: "50", label: "Firma Convenio - 50%" },
    { value: "75", label: "Salida Resolución - 75%" },
    { value: "100", label: "Firma Resolución - 100%" }
]

//crear un objeto de optionsUniversidades con label / nombre / iniciales
const optionsUniversidades = [
    { value: "Universidad Nacional de Mar del Plata", label: "Universidad Nacional de Mar del Plata", siglas: "UNMDP" },
    { value: "Universidad Nacional del Centro de la Provincia de Buenos Aires", label: "Universidad Nacional del Centro de la Provincia de Buenos Aires", siglas: "UNICEN" },
    { value: "Universidad Nacional del Sur", label: "Universidad Nacional del Sur", siglas: "UNS" },
    { value: "Universidad Provincial del Sudoeste", label: "Universidad Provincial del Sudoeste", siglas: "UPSO" },
    { value: "Universidad Nacional de San Antonio de Areco", label: "Universidad Nacional de San Antonio de Areco", siglas: "UNSAdA" },
    { value: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires", label: "Universidad Nacional del Noroeste de la Provincia de Buenos Aires", siglas: "UNNOBA" },
    { value: "Universidad Nacional Raúl Scalabrini Ortiz", label: "Universidad Nacional Raúl Scalabrini Ortiz", siglas: "UNSO" },
    { value: "Universidad Nacional Arturo Jauretche", label: "Universidad Nacional Arturo Jauretche", siglas: "UNAJ" },
    { value: "Universidad Nacional de Avellaneda", label: "Universidad Nacional de Avellaneda", siglas: "UNDAV" },
    { value: "Universidad Nacional de Hurlingham", label: "Universidad Nacional de Hurlingham", siglas: "UNAHUR" },
    { value: "Universidad Nacional de José C. Paz", label: "Universidad Nacional de José C. Paz", siglas: "UNPAZ" },
    { value: "Universidad Nacional de La Matanza", label: "Universidad Nacional de La Matanza", siglas: "UNLaM" },
    { value: "Universidad Nacional de La Plata", label: "Universidad Nacional de La Plata", siglas: "UNLP" },
    { value: "Universidad Nacional de Lanús", label: "Universidad Nacional de Lanús", siglas: "UNLa" },
    { value: "Universidad Nacional de Lomas de Zamora", label: "Universidad Nacional de Lomas de Zamora", siglas: "UNLZ" },
    { value: "Universidad Nacional de Luján", label: "Universidad Nacional de Luján", siglas: "UNLu" },
    { value: "Universidad Nacional de Moreno", label: "Universidad Nacional de Moreno", siglas: "UNM" },
    { value: "Universidad Nacional de Quilmes", label: "Universidad Nacional de Quilmes", siglas: "UNQ" },
    { value: "Universidad Nacional de San Martín", label: "Universidad Nacional de San Martín", siglas: "UNSAM" },
    { value: "Universidad Nacional de Tres de Febrero", label: "Universidad Nacional de Tres de Febrero", siglas: "UNTREF" },
    { value: "Universidad Nacional del Oeste", label: "Universidad Nacional del Oeste", siglas: "UNO" },
    { value: "Universidad Nacional Guillermo Brown", label: "Universidad Nacional Guillermo Brown", siglas: "UNaB" },
    { value: "Universidad Provincial de Ezeiza", label: "Universidad Provincial de Ezeiza", siglas: "UPE" },
    { value: "Universidad Tecnológica Nacional", label: "Universidad Tecnológica Nacional", siglas: "UTN" },
    { value: "Universidad Nacional de General Sarmiento", label: "Universidad Nacional de General Sarmiento", siglas: "UNGS" }
]


export {
    optionsPartido, optionsTipoSubsidio,
    optionsOrganismoSolicitante,
    optionsEncargadoProyecto,
    optionsPrograma, optionsProgramaUNO, optionsProgramaDOS, optionsProgramaTRES, optionsProgramaCUATRO, optionsProgramaCINCO, optionsProgramaSEIS,
    optionsModalidadUNO, optionsModalidadDOS, optionsModalidadCUATRO, optionsModalidadCUATRO_UNO, optionsModalidadSEIS,
    optionsTipoContratacion, optionsEstado, optionsTipoProyecto,
    optionsObjetoExpediente,
    optionsObjetoExpediente_Proyectos, optionsObjeto_Tramitacion_Pagos,
    optionsDocumentacionPresentada,
    optionsEtapaPago, optionsAvanceObra,
    optionsObjetoExpediente_Mejoras_Microcreditos,
    optionsIdentificacionCatastral, optionsBarrioTipo,
    optionsAreaResponsable, optionsCategoria, optionsLPO, optionsEncargadoRendicion, optionsOrganismoEncargado,
    optionsEncargadoSeguimiento,
    optionsEncargadoSeguimientoMejoras,
    optionsEtapaExpediente,
    optionsUniversidades
};
